import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';

/**
 * Link (de pagamento ou PIX) com botão de copiar. Sem link, mostra "—".
 */
export const CopyLink: React.FC<{ label: string; value: string; compact?: boolean }> = ({
  label,
  value,
  compact = false,
}) => {
  const [copied, setCopied] = useState(false);

  if (!value) {
    return compact ? <span className="text-xs text-slate-400">—</span> : null;
  }

  const copy = async (e: React.MouseEvent) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Sem permissão de clipboard: o link continua visível para copiar à mão.
    }
  };

  return (
    <div className="flex items-center gap-2 min-w-0">
      <span className="text-xs font-medium text-slate-600 flex-shrink-0">{label}:</span>
      <a
        href={value}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
        className={`text-xs text-blue-700 hover:underline truncate ${compact ? 'max-w-[180px]' : 'max-w-[420px]'}`}
        title={value}
      >
        {value}
      </a>
      <button
        type="button"
        onClick={copy}
        className="p-1 rounded text-slate-500 hover:text-slate-800 hover:bg-slate-100 flex-shrink-0"
        title={copied ? 'Copiado!' : `Copiar ${label.toLowerCase()}`}
      >
        {copied ? <Check size={14} className="text-emerald-600" /> : <Copy size={14} />}
      </button>
    </div>
  );
};
